import { doAjax, initStitchesBackgroundColorListeners, initColorSelect, fakeSelected, changeStitchBackgroundColor } from './helper'
import { getColorByCode } from './color-languages'


const initPillowSelectLogic = () => {
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
	const thirdSeatRow = document.querySelector("input[name=thirdseatrow]").value;
	initColorSelect()
	loadBasicColorSeatLayers(frontSeatModel,backSeatModel)

	let frontseatComponents = ['headrestSide','headrestFront','headrestRear','shoulderArch',
	'shoulderBolsters','thighPad','bolstersOutside','seatCenterPanel','seatSideBolstersInside','circumferentialBand','backrestTop',
	'seatSideBolstersOutside','contrastStitchingSide','contrastStitchingCenter','contrastStitchingHoneycombQuilting',
	'contrastStitchingDiamondQuilting','embossing','biese','headrestFront2','seatCenterPanel2','seatSportStripe', 'backrestCover','seatCover2']

	frontseatComponents.forEach(component => {
		initRedPointLogic('frontSeat', component)
		checkCustomizedComponentsOnLoading('frontSeat', component)
	});

	let backseatComponents = ['headrestFront','headrestSide','headrestRear','centerHeadrestFront',
	'centerHeadrestSide','centerHeadrestRear','shoulderArch','thighPad','bolstersOutside','bolstersCenter',
	'seatCenterPanel','seatSideBolstersInside','circumferentialBand','circumferentialBand2','backrestTop',
	'seatSideBolstersOutside','seatSideBolstersOutside2','rearCenterArmrest','seatCenterSectionAbove',
	'seatCenterSectionBottom','contrastStitchingCenterHeadrest','contrastStitchingSide','contrastStitchingCenter','contrastStitchingHoneycombQuilting',
	'contrastStitchingDiamondQuilting','biese','headrestFront2','seatCenterThighPad','seatCenterShoulderArch',
	'seatCenterBolster','seatCenterBolsterBottom','seatCenterMiddle','seatSideBolstersBottom','seatMiddle',
	'seatCenterPanel2','seatSportStripe','headrestPillow','extraPillow','audiRingsStiching']

	backseatComponents.forEach(component => {
		initRedPointLogic('backSeat', component)
		checkCustomizedComponentsOnLoading('backSeat', component)
	});

	checkCustomizedComponentsOnLoading('backSeat', 'upholsteryBarOutside') //special case
	
	if((frontSeatModel != 'Q2J_AU53X') && (frontSeatModel != 'Q1D_AU53X')) {
			initStitchesBackgroundColorListeners(getBackSeatComponentDotId('extraPillow'), getBackSeatComponentDotId('audiRingsStiching'))
			/*
			initStitchesBackgroundColorListeners(getBackSeatComponentDotId('seatCenterPanel'), getBackSeatComponentDotId('contrastStitchingHoneycombQuilting'))
			initStitchesBackgroundColorListeners(getFrontSeatComponentDotId('seatCenterPanel'), getFrontSeatComponentDotId('contrastStitchingDiamondQuilting'))
			initStitchesBackgroundColorListeners(getBackSeatComponentDotId('seatCenterPanel'), getBackSeatComponentDotId('contrastStitchingDiamondQuilting'))
			initStitchesBackgroundColorListeners(getFrontSeatComponentDotId('seatCenterPanel'), getFrontSeatComponentDotId('contrastStitchingCenter'))
			initStitchesBackgroundColorListeners(getBackSeatComponentDotId('seatCenterPanel'), getBackSeatComponentDotId('contrastStitchingCenter'))
			*/
	}

	
	
}

const initRedPointLogic = (seatType, component) => {
	const componentMatchingDotId = seatType == "frontSeat" ? getFrontSeatComponentDotId(component) : getBackSeatComponentDotId(component)
	const componentTiles = document.querySelectorAll('#' + componentMatchingDotId + ' .color')
	const mainSeatColorCode = document.querySelector('#picked-color td[color-code]')?.getAttribute('color-code')
	componentTiles?.forEach(element => {
		element.addEventListener("click", function (e) {
			e.preventDefault()
			const componentColorCode = element.querySelector('input')?.value
			const frontSeatComponentColorCode = document.querySelector('#seat-components #' + component + ' td[name=frontseat]')?.getAttribute('color-code')
			const backSeatComponentColorCode = document.querySelector('#seat-components #' + component + '  td[name=backseat]')?.getAttribute('color-code')

			//Special audiRingsStiching 
			const audiRingsStichingColorCode = document.querySelector('#seat-components #audiRingsStiching td[name=backseat]')?.getAttribute('color-code')
			const extraPillowColorCode = document.querySelector('#seat-components #extraPillow td[name=backseat]')?.getAttribute('color-code')
			if (component == "extraPillow" && extraPillowColorCode == audiRingsStichingColorCode) {

				setImageOnSeat("backSeat", 'audiRingsStiching', componentColorCode);
				fakeSelected('backseat #' + getBackSeatComponentDotId(component), componentColorCode)
			}
			
			setImageOnSeat(seatType, component, componentColorCode)
			
		})
	})
}

function getFrontSeatComponentDotId(component) {
	switch (component) {
		case 'headrestSide': return 'headrestSide'
		case 'headrestFront': return 'headrestFront'
		case 'headrestRear': return 'headrestRear'
		case 'shoulderArch': return 'shoulderArch'
		case 'shoulderBolsters': return 'shoulderBolsters'
		case 'thighPad': return 'thighPad'
		case 'bolstersOutside': return 'bolstersOutside'
		case 'seatCenterPanel': return 'seatCenterPanel'
		case 'seatSideBolstersInside': return 'seatSideBolstersInside'
		case 'circumferentialBand': return 'circumferentialBand'
		case 'seatSideBolstersOutside': return 'seatSideBolstersOutside'
		case 'backrestTop': return 'backrestTop'
		case 'contrastStitchingSide': return 'contrastStitchingSide'
		case 'contrastStitchingCenter': return 'contrastStitchingCenter'
		case 'contrastStitchingHoneycombQuilting': return 'contrastStitchingHoneycombQuilting'
		case 'contrastStitchingDiamondQuilting': return 'contrastStitchingDiamondQuilting'
		case 'embossing': return 'embossing'
		case 'biese': return 'biese'
		case 'headrestFront2': return 'headrestFront2'
		case 'seatCenterPanel2': return 'seatCenterPanel2'
		case 'seatSportStripe': return 'seatSportStripe'
		case 'backrestCover': return 'backrestCover'
		case 'seatCover2': return 'seatCover2'
		default:
			break;
	}
}

function getBackSeatComponentDotId(component) {
	switch (component) {
		case 'headrestFront': return 'back-headrestFront'
		case 'headrestSide': return 'back-headrestSide'
		case 'headrestRear': return 'back-headrestRear'
		case 'centerHeadrestFront': return 'back-centerHeadrestFront'
		case 'centerHeadrestSide': return 'back-centerHeadrestSide'
		case 'centerHeadrestRear': return 'back-centerHeadrestRear'
		case 'shoulderArch': return 'back-shoulderArch'
		case 'thighPad': return 'back-thighPad'
		case 'bolstersOutside': return 'back-bolstersOutside'
		case 'bolstersCenter': return 'back-bolstersCenter'
		case 'seatCenterPanel': return 'back-seatCenterPanel'
		case 'seatSideBolstersInside': return 'back-seatSideBolstersInside'
		case 'circumferentialBand': return 'back-circumferentialBand'
		case 'circumferentialBand2': return 'back-circumferentialBand2'
		case 'seatSideBolstersOutside': return 'back-seatSideBolstersOutside'
		case 'seatSideBolstersOutside2': return 'back-seatSideBolstersOutside2'
		case 'backrestTop': return 'back-backrestTop'
		case 'rearCenterArmrest': return 'back-rearCenterArmrest'
		case 'seatCenterSectionAbove': return 'back-seatCenterSectionAbove'
		case 'seatCenterSectionBottom': return 'back-seatCenterSectionBottom'
		case 'contrastStitchingCenterHeadrest': return 'back-contrastStitchingCenterHeadrest'
		case 'contrastStitchingSide': return 'back-contrastStitchingSide'
		case 'contrastStitchingCenter': return 'back-contrastStitchingCenter'
		case 'contrastStitchingHoneycombQuilting': return 'back-contrastStitchingHoneycombQuilting'
		case 'contrastStitchingDiamondQuilting': return 'back-contrastStitchingDiamondQuilting'
		case 'biese': return 'back-biese'
		case 'headrestFront2': return 'back-headrestFront2'
		case 'seatCenterThighPad': return 'back-seatCenterThighPad'
		case 'seatCenterShoulderArch': return 'back-seatCenterShoulderArch'
		case 'seatCenterBolster': return 'back-seatCenterBolster'
		case 'seatCenterBolsterBottom': return 'back-seatCenterBolsterBottom'
		case 'seatCenterMiddle': return 'back-seatCenterMiddle'
		case 'seatSideBolstersBottom': return 'back-seatSideBolstersBottom'
		case 'seatMiddle': return 'back-seatMiddle'
		case 'seatCenterPanel2': return 'back-seatCenterPanel2'
		case 'seatSportStripe': return 'back-seatSportStripe'
		case 'headrestPillow': return 'back-headrestPillow'
		case 'extraPillow': return 'back-extraPillow'
		case 'audiRingsStiching': return 'back-audiRingsStiching'
		default:
			break;
	}

}

function setImageOnSeat(seatType, component, colorCode) {
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
	const seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value;
	replaceImage(seatType, component, colorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	if (component != 'upholsteryBarOutside') {
		updateTableValue(seatType, component, colorCode)
	}
	const seatJson = createSeatJson(seatType, component, colorCode)
	doAjax(seatJson)
}

function replaceImage(seatType, component, colorCode, frontSeatModel, backSeatModel, seatComponentSelection) {
	const thirdSeatRow = document.querySelector("input[name=thirdseatrow]").value;
	const q1dembossing = document.querySelector("input[name=q1dembossing]").value;
	const modelcategory = document.querySelector("input[name=modelcategory]").value;
	let thirdRowComponents = ['headrestSide', 'headrestFront','contrastStitchingSide','thighPad',
		'bolstersOutside','shoulderArch','seatSideBolstersInside','seatCenterPanel2',
		'seatSportStripe','circumferentialBand'];
	if (seatType == 'backSeat' && thirdSeatRow && thirdRowComponents.includes(component)) {
		replaceImage('thirdSeatRow', component, colorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	}
	// fake select no component in backseat
	if (seatType == 'thirdSeatRow' && frontSeatModel == 'Q4Q_AU53X' && component == 'seatCenterPanel2') {
		replaceImage('thirdSeatRow', 'seatSportStripe', colorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	}
	var element_id = ''
	var element_class = ''
	var seatarrayname = ''
	if (seatType == 'frontSeat') {
		element_id = 'seat-single'
		element_class = '.wrapper-relative img.overlay'
		seatarrayname = 'frontseat_'+frontSeatModel+'_component_path'
	} else if (seatType == 'backSeat') {
		element_id = 'backseat'
		element_class = '.wrapper-relative img.overlay'
		seatarrayname = 'backseat_'+frontSeatModel+'_'+backSeatModel+'_component_path'
		if ( component == 'headrestPillow' || component == 'extraPillow' || component == 'audiRingsStiching' ) {
			seatarrayname = 'backseat_YXK_component_path'
		}
	} else { // third seat row
		element_id = 'third-row'
		element_class = '.wrapper-relative-third-row img.overlay'
		seatarrayname = 'thirdseatrow_q7_component_path'
	} 
	if ((document.getElementById(component) || seatType == 'thirdSeatRow') && colorCode != undefined) {
		var componentPictureName = aeo['components']['seat_components_screen'+seatComponentSelection][component] + '.png';
		if(q1dembossing && component == 'backrestTop' && modelcategory != 'a8') {
			componentPictureName = aeo['components']['seat_components_screen'+seatComponentSelection+q1dembossing][component] + '.png';
		}
		if(q1dembossing && component == 'shoulderArch' && modelcategory == 'a8') { // only A8
			if (seatType == 'frontSeat') {
				componentPictureName = aeo['components']['seat_components_screen'+seatComponentSelection+q1dembossing+'_A8'][component] + '.png';	
			}
		}
		//const imageSource = aeo['paths'][seatType == 'frontSeat' ? 'frontseat_'+frontSeatModel+'_component_path' : 'backseat_'+frontSeatModel+'_'+backSeatModel+'_component_path'][colorCode] + componentPictureName
		const imageSource = aeo['paths'][seatarrayname][colorCode] + componentPictureName
		
		//let imageArray = document.getElementById(seatType == 'frontSeat' ? 'seat-single' : 'backseat').querySelectorAll('.wrapper-relative img.overlay')
		let imageArray = document.getElementById(element_id).querySelectorAll(element_class)
		const imageId = component + '-img'
		let imageExists = false;
		imageArray.forEach(element => {
			if (element.id != null && element.id == imageId) {
				imageExists = true
				element.src = imageSource
			}
		});
		if (!imageExists && imageArray.length > 0) {
			let newImage = document.createElement('IMG')
			newImage.classList.add('overlay')
			newImage.id = component + '-img'
			imageArray[imageArray.length - 1].insertAdjacentElement('afterend', newImage)
			newImage.src = imageSource
		}
	}
	
}

function updateTableValue(seatType, component, colorCode) {
	let query = '#seat-components #' + component + ' td[name=\"' + (seatType == 'frontSeat' ? 'frontseat' : 'backseat') + '\"]'
	let valueOnTable = document.querySelector(query)
	valueOnTable.setAttribute('color-code', colorCode)
	valueOnTable.innerHTML = getColorByCode(colorCode)
}


function createSeatJson(seatType, component, colorCode) {
	const json = {};
	json[seatType + 'Component'] = true
	json[component + 'PressedColor'] = colorCode
	return json;
}


function loadBasicColorSeatLayers(frontSeatModel,backSeatModel) {
	const seatColorCode = document.querySelector('#picked-color td[color-code]')?.getAttribute('color-code').toString()
	const stitchSeatColorCode = document.querySelector('#picked-stitch td[color-code]')?.getAttribute('color-code').toString()
	const q1dembossing = document.querySelector("input[name=q1dembossing]").value;
	const seatTypes = ["frontSeat", "backSeat"]
	seatTypes.forEach(seatType => {
		const seatColorSrc = aeo['images'][seatType == "frontSeat" ? 'frontseat_'+frontSeatModel+'_color' : 'backseat_'+frontSeatModel+'_'+backSeatModel+'_color'][seatColorCode]
		const stitchColorSrc = aeo['images'][seatType == "frontSeat" ? 'frontseat_'+frontSeatModel+'_stitch_color' : 'backseat_'+frontSeatModel+'_'+backSeatModel+'_stitch_color'][stitchSeatColorCode]
		var embossingColorSrc = "/img/03_sitze/front_empty.png"
		if(q1dembossing && seatType == "frontSeat") {
			embossingColorSrc = aeo['images']['frontseat_'+frontSeatModel+q1dembossing+'_color'][seatColorCode]
		}
		const imgSources = [embossingColorSrc, seatColorSrc, stitchColorSrc]
		imgSources.forEach(imageSource => {
			const query = '#' + (seatType == 'frontSeat' ? 'seat-single' : 'backseat') + ' img[alt="seat-base"]'
			let baseImage = document.querySelector(query)
			let newImage = document.createElement('IMG')
			newImage.classList.add('overlay')
			newImage.id = seatType + 'basis-img'
			baseImage.insertAdjacentElement('afterend', newImage)
			newImage.src = imageSource
		})
	})
}

/** Loads already customized components */
function checkCustomizedComponentsOnLoading(seatType, component) {

	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
	const seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value;
	const seatTypeNameValue = seatType == "frontSeat" ? "frontseat" : "backseat"
	let query = `#seat-components #${component} td[name="${seatTypeNameValue}"]`
	if (component == 'upholsteryBarOutside') {
		query = `#seat-components #seatCenterPanel td[name="${seatTypeNameValue}"]`
	}
	let componentColorCode = document.querySelector(query)?.getAttribute('color-code')
	const mainSeatColorCode = document.querySelector('#picked-color td[color-code]')?.getAttribute('color-code')
	if (componentColorCode != mainSeatColorCode ) {
		replaceImage(seatType, component, componentColorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	}
	let pillowComponents = ['headrestPillow','extraPillow','audiRingsStiching'];
	if (pillowComponents.includes(component)) {
		replaceImage(seatType, component, componentColorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	}
}

export { initPillowSelectLogic, loadBasicColorSeatLayers };